export default function getTotalAmountTendered(order = {}) {
  if (order.payments === undefined) return 0
  return order.payments.reduce((amount, payment) => {
    return payment.amountTendered + amount
  }, 0)
}
